import { render, staticRenderFns } from "./myLike.vue?vue&type=template&id=15ee6242&scoped=true&"
import script from "./myLike.vue?vue&type=script&lang=js&"
export * from "./myLike.vue?vue&type=script&lang=js&"
import style0 from "./myLike.vue?vue&type=style&index=0&id=15ee6242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee6242",
  null
  
)

export default component.exports